document.addEventListener("DOMContentLoaded", () => {
  const desktopQuery = window.matchMedia("(min-width: 990px)");
  const menuDetails = document.querySelectorAll("header details");

  menuDetails.forEach((details) => {
    let closeTimer;

    const cancelClose = () => {
      window.clearTimeout(closeTimer);
    };

    const scheduleClose = () => {
      if (!desktopQuery.matches) return;

      closeTimer = window.setTimeout(() => {
        details.removeAttribute("open");
      }, 350);
    };

    details.addEventListener("mouseenter", cancelClose);
    details.addEventListener("mouseleave", scheduleClose);

    const submenu = details.querySelector(
      'ul, [class*="submenu"], [class*="dropdown"]'
    );

    if (submenu) {
      submenu.addEventListener("mouseenter", cancelClose);
      submenu.addEventListener("mouseleave", scheduleClose);
    }
  });
});